import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFastDelivery: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="fast-delivery, quick-commerce"><path d="M12.75 20.25H20.25V3.75H3.75V9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 3.75V9.25H15.25V3.75" stroke="currentColor" strokeWidth="1.5"/><path d="M1.75 17H6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 20.25H8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 13.75L8.25 13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFastDelivery;
